import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../stores/store";
import { useEffect } from "react";
import { fetchInfos } from "../../stores/slices/infoSlice";


const Info = () => {
  const infoData = useSelector((state: RootState) => state.infos.infos);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchInfos());
  }, [dispatch]);

  const toEdit = (id: number) => {
    navigate(`/info/edit/${id}`);
  }

  return (
    <>
      <h2>お知らせ一覧</h2>
      <div className="submit big">
        <Link to={"/info/new"}>新規登録</Link>
      </div>
      <div className="tableDataList">
        <table>
          <tbody>
            <tr>
              <th>ID</th>
              <th>タイトル</th>
              <th>本文</th>
              <th>リンク先</th>
              <th>登録日</th>
              <th>更新日</th>
              <th style={{minWidth: '80px'}}>ステータス</th>
            </tr>

            {infoData.map((info : any) => (
              <tr onClick={() => toEdit(info.id)} style={{ cursor: 'pointer'}} key={info.id}>
                <td>
                  {info.id}
                </td>
                <td>
                  {info.title}
                </td>
                <td>
                  {info.body}
                </td>
                <td>
                  {info.link}
                </td>
                <td>
                  {info.created_at}
                </td>
                <td>
                  {info.updated_at}
                </td>
                <td>
                  {info.status === 0 ? ( 
                    <span>公開</span>
                  ):(
                    <span>非公開</span>
                  )}
                </td>
                <td>
                  <div className="submit">
                    <Link to={`/info/edit/${info.id}`}>登録</Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Info;